<img class="logo1" alt="logo" src="../assets/img/logo-dark.png" fxHide fxShow.gt-sm>&nbsp;&nbsp;&nbsp;&nbsp;
<div class="user-button-container" #userButton (vrClickOutside)="onClickOutside()">
    <button class="user-button" mat-button (click)="toggleDropdown()" [class.open]="isOpen">
    <span fxLayout="row" fxLayoutAlign="start center">
      <span class="avatar-container" fxLayout="row" fxLayoutAlign="start center">
      <!--    <img class="logo1" alt="logo" src="../assets/img/logo.svg" fxHide fxShow.gt-sm>&nbsp;&nbsp;&nbsp;&nbsp;-->
          <span class="name" fxHide fxShow.gt-sm><b>{{user}}</b></span><img class="avatar" src="assets/img/demo/avatars/noavatar.png">
      <!--  <i class="status primary"></i>-->
      </span>

      <mat-icon class="icon" fxHide fxShow.gt-sm>keyboard_arrow_down</mat-icon>
    </span>
    </button>

    <div class="dropdown mat-elevation-z1" [class.open]="isOpen">
        <div class="content">
            <div class="list">
                <!--{{user}}-->
             <!--   <div class="item" fxLayout="row" fxLayoutAlign="start center" matRipple>
                    <mat-icon class="icon">account_circle</mat-icon>
                    <span class="title" [routerLink]="['/settings/profile']">Profile</span>
                </div>-->
                <div class="item" fxLayout="row" fxLayoutAlign="start center" matRipple [routerLink]="['/auth/login']">
                    <mat-icon class="icon">exit_to_app</mat-icon>
                    <span class="title">Logout</span>
                </div>
            </div>
        </div>
    </div>
</div>
